import { fetchApi } from 'api/fetchApi'
import { paths as messengerOutsideContacts } from 'api/generated/messenger_outside_contacts'

type Response =
  messengerOutsideContacts['/messenger/outsideContacts/all']['get']['responses']['200']['schema']

export const fetchOutsideContactsApi = () => {
  return fetchApi<Response>('/messenger/outsideContacts/all')
}
